import { getIntroIndex } from "@/api";

const actions = {
  async getIndexData({ commit }) {
    let res = await getIntroIndex();
    commit("SAVE_INDEX_DATA", res);
  },
};

const mutations = {
  SAVE_INDEX_DATA(state, data) {
    state.introduction = data.introduction;
    state.hot_news = data.hot_news;
    state.product = data.product;
  },
};

const state = {
  introduction: {},
  hot_news: [],
  product: [],
};

const getters = {
	// 轮播图数据的处理, 4个一组，二维数组
  swiperData(state) {
    const length = 4 - (state.hot_news % 4);
    for (let i = 0; i < length; i++) {
      state.hot_news.push(state.hot_news[i]);
    }
	console.log(state.hot_news)
    let result = [];
    for (let i = 0; i < state.hot_news.length; i += 4) {
      result.push(state.hot_news.slice(i, i + 4));
    }
	console.log(result)
    return result;
  },
};

export default {
  actions,
  mutations,
  state,
  getters,
};
